export const AgentsActionTypes = {
    API_RESPONSE_SUCCESS: '@@agents/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@agents/API_RESPONSE_ERROR',
    READ_AGENTS_REQUEST: '@@agents/READ_AGENTS_REQUEST',
    CREATE_AGENT_REQUEST: '@@agents/CREATE_AGENT_REQUEST',
    UPDATE_AGENT_REQUEST: '@@agents/UPDATE_AGENT_REQUEST',
    DELETE_AGENT_REQUEST: '@@agents/DELETE_AGENT_REQUEST',
    RESET_AGENT_STATE: '@@agents/RESET_AGENT_STATE',
};
